import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=3593d10b&"
import script from "./GameBoard.vue?vue&type=script&lang=js&"
export * from "./GameBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports